// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__Q3ix0","content":"Popup_content__yi+PX","withPadding":"Popup_withPadding__ylJwA"};